/**
 * 购物车
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/4/13      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */


import React from "react";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import "./index.less";
import Statistics from "./components/Statistics";
// import GoodsList from "./components/GoodsList";
import CommonList from "./components/commonList/commonList"
import Lang from "../../components/Lang/Lang";
import {Form, DatePicker, Select, Input, Pagination, Spin, Button,message} from "antd";
import qs from 'query-string';
import dayjs from 'dayjs';
import Cookie from "@utils/cookie";
import {isEmpty,getHandlerURL,postHttpAction} from "@utils/utils";
import { Link } from "react-router-dom";
import Locale from "@utils/locale";
const localeLang = Locale.current();
const { RangePicker } = DatePicker;
const { Search } = Input;

class Cart extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            //加载中
            loading:true,
            //数据源
            list:[],
            pageSize:50,
            pageIndex:1,
            total:0,
            extra:{},
            model:{}
        }
        this.id = (qs.parse(props.location.search)||{}).id;
        this.params = {

        }
    }

    /**
     * 搜索回调
     * @param value
     */
    onSearch = (value) => {
        this.params.keyword = value;
        this.getData(1);
    }

    /**
     * 时间回调
     */
    onTimeChange=(dates,dateStrings)=>{
        this.params.startTime = '';
        this.params.endTime = '';
        if(dates&&dates[0]){
            this.params.startTime = dates[0].format('YYYY/MM/DD');
            this.params.startTime = dayjs(this.params.startTime).valueOf()
        }
        if(dates&&dates[1]){
            this.params.endTime = dates[1].format('YYYY/MM/DD');
            this.params.endTime = dayjs(this.params.endTime).valueOf();
            this.params.endTime = String(parseInt(this.params.endTime) + 86399000);
        }
        this.getData(1);
        // console.log(this.params.endTime,"this.params.endTime");
    }

    /**
     * 切换分页
     * @param page 切换到第几页
     * @param pageSize
     **/
    onChangePage=(page, pageSize)=> {
        this.getData(page, pageSize)
    }

    /**
     * 获取统计数据
     */
    getCountData(){
        $.ajax({
            url: "/mg/po/essa-one/shopping-cart-goods-Statistics",
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify({
                buyerId:this.id
            }),
            success:(res)=>{
                if(res.success&&res.valid){
                    this.setState({
                        model:res.model||{}
                    })
                }
            }
        });
    }


    /**
     * 获取数据
     **/
    getData(pageIndex, pageSize){
        this.setState({
            loading:true
        }, () =>{
            let postData = {
                buyerId:this.id,
                pagingQuery: {
                    pageIndex: pageIndex||this.state.pageIndex,
                    pageSize: pageSize||this.state.pageSize
                }
            }

            if(this.params.startTime){
                postData.startTime = this.params.startTime;
            }
            if(this.params.endTime){
                postData.endTime = this.params.endTime;
            }
            if(this.params.keyword){
                postData.keyword = this.params.keyword;
            }
            if(this.params.type){
                postData.type = this.params.type;
            }
            if(this.params.inquiryStatus){
                postData.inquiryStatus = this.params.inquiryStatus;
            }


            $.ajax({
                url: "/mg/po/essa-one/shopping-cart-goods-list",
                type:'post',
                dataType: "json",
                contentType: 'application/json',
                data:JSON.stringify(postData),
                success:(res)=>{
                    let data = {
                        loading:false
                    }
                    if(res.success&&res.valid){
                        (res.models||[]).map(function (item,index) {
                            return item.key = index;
                        })
                        data = Object.assign(data,{
                            list:res.models||[],
                            extra:res.extra
                        })
                    }
                    //分页
                    if(res.paging){
                        data = Object.assign(data,{
                            pageIndex:res.paging.pageNum,
                            pageSize: res.paging.pageSize,
                            total:res.paging.total
                        })
                    }
                    this.setState(data)
                },
                error:()=>{
                    let data = {
                        loading:false,
                    }
                    this.setState(data)
                }
            });
        });
    }

    /**
     * 确认状态回调
     **/
    handleChange=(value)=>{
        this.params.inquiryStatus = value;
        this.getData(1);
    }

    init(){
        const {fxUserId} = Cookie.getJSON("fmg.extra") || {};
        this.setState({
            fxUserId:fxUserId||""
        })
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    exportData(){
       const selectedItemObj =  this.onRefChildOne.getSelectItems()
       const selectedItems = Object.keys(selectedItemObj).filter(key => selectedItemObj[key]);
        if(!selectedItems||selectedItems.length==0){
            message.warning(Lang({id: 'QingXuanZeShangPin', default: '请选择商品'}));
            return false
        }
        this.loading(true);
        postHttpAction("/service/mg/follower/user/buyerId",{
            id: this.id,
        },(resData)=>{
            console.log("导出 res",resData)
            const { success, valid,model={}} = resData;
            if (success &&valid) {
                let template=""
                switch (localeLang) {
                    //    中文模板code : ShoppingCartReport_common_ddp_zh
                    // 英文模板code : ShoppingCartReport_common_ddp_en
                    // 俄文模板code : ShoppingCartReport_common_ddp_ru
                    case 'zh':
                        template = 'ShoppingCartReport_common_ddp_zh';
                        break;
                    case 'en':
                        template = 'ShoppingCartReport_common_ddp_en';
                        break;
                    case 'ru':
                        template = 'ShoppingCartReport_common_ddp_ru';
                        break;
                    default:
                        template = 'ShoppingCartReport_common_ddp_ru';
                        return;
                }
                const {extra} = this.state;
                this.printReport(
                    {
                        ids: selectedItems,
                        template: {
                            resid: template,
                            langCode:localeLang,
                            buyerId:this.id,
                            currencyCode:extra.currencySymbol,
                            // cityCode:model.cityCode
                        },
                        href: "/data/bpms/jreport/invoice/print",
                    },
                    {
                        cityCode: model.cityCode, //DDP 收货城市
                    }
                );
            }else{
                message.warning(resData.message||Lang({id: 'CaoZuoShiBai', default: '操作失败'}))
                this.loading(false);
            }
    });

    }
    /**
     * 获取报表资源
     * this.printReport
     * 来源 bportal-webapp/public/raw/common/components/angular/reportFactory/index.js
     */
    printReport(postData , extendParame){
        //如果没有选中，则为全部商品id
        const _ids = postData.ids;
        // if (_ids.length == 0) { // 前面已校验 可忽略
        let _params = {
            // containerTypeId: postData.template.containerTypeId,
            // portId: postData.template.portId,                              //下水港ID
            quoteType: 'd',                              //报价方式
            // areaId: postData.template.areaId,
            ids: _ids.join(",")
        };
        if(extendParame){
            _params = {..._params, ...extendParame}
        }
        const _url = getHandlerURL(postData.href, _params, postData.template);
        console.log("_url",_url)
        window.open(_url);
        this.loading(false);
    }
    onRefOne = (ref) =>this.onRefChildOne = ref;
    componentDidMount() {
        this.init();
        this.getData();
        this.getCountData();
    }


    render(){
        let {list,extra,model,loading,fxUserId} = this.state;
        let state = this.state;
        return (
            <div>
                {/* 分销商 账号 不显示面包屑 */}
                {isEmpty(fxUserId)&&<CommonBreadcrumb list={[{ name:__getServerLanguage('CaiGouShangHangWeiShuJu'),link:'/dataStatistics/behavior'},{name:__getServerLanguage('GouWuChe')}]}></CommonBreadcrumb>}
                <div className="main-wrap cart-wrap">
                    <Spin spinning={loading}>
                        {/*头部*/}
                        <div className="title-wrap">
                            <span className="title">{__getServerLanguage('GouWuChe')}</span>
                            <span className="num"><Link to={`/customer/detail?id=${model.buyerId}`}>{model.buyerCode}</Link></span>
                        </div>

                        {/*统计*/}
                        <Statistics model={model}></Statistics>

                        {/*操作栏*/}
                        <div className="option-wrap">
                            <Form layout="inline">
                                <Form.Item
                                    label={<Lang id="JiaRuShiJian">加入时间</Lang>}
                                >
                                    <RangePicker
                                        style={{ width: "100%" }}
                                        placeholder={[
                                            Lang({
                                                id: "KaiShiShiJian",
                                                default: "开始时间",
                                            }),
                                            Lang({
                                                id: "JieShuShiJian",
                                                default: "结束时间",
                                            }),
                                        ]}
                                        onChange={this.onTimeChange}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Select defaultValue="" onChange={this.handleChange} placeholder={__getServerLanguage('XunJiaZhuangTaiOne')}>
                                        <Select.Option value="">{__getServerLanguage('QuanBuZhuangTai')}</Select.Option>
                                        <Select.Option value="1">{__getServerLanguage('DaiQueRen1')}</Select.Option>
                                        <Select.Option value="2">{__getServerLanguage('YiQueRen')}</Select.Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item>
                                    <Search placeholder={__getServerLanguage('ShangPinBianHaoHuoMingCheng2')} allowClear onSearch={this.onSearch} style={{ width: 300 }} />
                                </Form.Item>
                            </Form>
                            <Button icon={<i className="ri-logout-box-r-line"></i>} onClick={()=>this.exportData()}>{Lang({id: 'DaoChu', default: '导出'})}</Button>
                        </div>

                        {/*表格*/}
                        {/*<GoodsList extra={extra} list={list}></GoodsList>*/}
                        <CommonList onRef={this.onRefOne}
                                    list={list}
                                    extra={extra}
                                    loading={loading}
                        />
                        {/*分页*/}
                        <div className="pagination-wrap" style={{display:list.length>0?"block":"none"}}>
                            <Pagination showQuickJumper
                                        showTotal={total => (
                                            `Total ${total} items`
                                        )}
                                        current={state.pageIndex||1}
                                        defaultPageSize={state.pageSize||10}
                                        defaultCurrent={state.pageIndex||1}
                                        total={state.total||0}
                                        onChange={this.onChangePage.bind(this)} />
                        </div>
                    </Spin>

                </div>
            </div>
        )
    }
}

Cart.defaultProps = {
}

Cart.propTypes = {

}
export default Cart;
